import { Box, Heading, VStack } from '@chakra-ui/react'
import type { ReportBlock, ReportResult } from '../../types/reporting'
import { StatRowBlockView } from './blocks/StatRowBlockView'
import { TableBlockView } from './blocks/TableBlockView'
import { CalloutBlockView } from './blocks/CalloutBlockView'
import { ChartBlockView } from './blocks/ChartBlockView'
import { ImageBlockView } from './blocks/ImageBlockView'
import { NotesBlockView } from './blocks/NotesBlockView'
import './report-print.css'

interface Props {
  result: ReportResult
  onExportCsv?: (blockId: string) => void
}

function BlockView({ block, onExportCsv }: { block: ReportBlock; onExportCsv?: (id: string) => void }) {
  switch (block.kind) {
    case 'statRow': return <StatRowBlockView block={block} />
    case 'table': return <TableBlockView block={block} onExportCsv={onExportCsv} />
    case 'callout': return <CalloutBlockView block={block} />
    case 'chart': return <ChartBlockView block={block} onExportCsv={onExportCsv} />
    case 'image': return <ImageBlockView block={block} />
    case 'notes': return <NotesBlockView block={block} />
    default: return null
  }
}

/**
 * The single component A6 restyles. Every report in the app renders through it, so a design
 * change lands everywhere at once instead of drifting page by page.
 */
export function ReportRenderer({ result, onExportCsv }: Props) {
  return (
    <VStack align="stretch" gap={8}>
      {result.sections.map((section) => (
        <Box key={section.title} className="report-section">
          <Heading size="md" mb={3}>{section.title}</Heading>
          <VStack align="stretch" gap={4}>
            {section.blocks.map((block) => (
              <BlockView key={block.id} block={block} onExportCsv={onExportCsv} />
            ))}
          </VStack>
        </Box>
      ))}
    </VStack>
  )
}
